import { getRangeInputError } from '@aibees/shared/utils';
import { useMemo } from 'react';
import { LimitType, TimeType } from '../types';

export function useGetDurationFilterError(currentValue: string[][]) {
  return useMemo(() => {
    const minYear = currentValue[LimitType.MIN][TimeType.YEAR]
      ? Number(currentValue[LimitType.MIN][TimeType.YEAR])
      : 0;
    const minMonth = currentValue[LimitType.MIN][TimeType.MONTH]
      ? Number(currentValue[LimitType.MIN][TimeType.MONTH])
      : 0;
    const maxYear = currentValue[LimitType.MAX][TimeType.YEAR]
      ? Number(currentValue[LimitType.MAX][TimeType.YEAR])
      : 0;
    const maxMonth = currentValue[LimitType.MAX][TimeType.MONTH]
      ? Number(currentValue[LimitType.MAX][TimeType.MONTH])
      : 0;

    const minMonthCount = minYear * 12 + minMonth;
    const maxMonthCount = maxYear * 12 + maxMonth;
    return getRangeInputError(
      minMonthCount === 0 ? undefined : minMonthCount.toString(),
      maxMonthCount === 0 ? undefined : maxMonthCount.toString()
    );
  }, [currentValue]);
}
